

















import Vue from 'vue';
export default Vue.extend({
  name: 'PageIntro',
  props: {
    heading: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    showCTA: {
      type: Boolean,
      default: false,
    },
    ctaConfig: {
      type: Object as () => any,
      default() {
        return {};
      },
    },
  },
});
